import { Link } from "react-router-dom";
import GradientText from "../components/GradientText";
import Seo from "../components/Seo";

const neonColors = ["#ff43b8", "#2ed4ff", "#ff8a22", "#39d353", "#8b49ff"];

export default function CateringPage() {
  return (
    <>
      <Seo
        title="Catering"
        description="Book Retro Grill catering for private parties, corporate lunches, weddings, school events, and community gatherings."
        path="/catering"
        image="/images/RetroGrillLogo.webp"
      />
      {/* Page Header */}
      <section className="relative pt-[calc(80px+60px)] pb-[60px] px-6 text-center overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <div className="absolute inset-0 page-header-gradient-bg"></div>
          <div className="absolute inset-0 hero-grid-bg"></div>
        </div>
        <div className="container">
          <GradientText
            colors={neonColors}
            animationSpeed={6}
            className="text-[clamp(2.5rem,8vw,4.5rem)] mb-4 font-display font-semibold"
          >
            Catering
          </GradientText>
          <p className="text-xl text-text-secondary font-light">
            Bring Retro Grill flavor to your next event
          </p>
        </div>
      </section>

      {/* Catering Content */}
      <section className="py-[80px] bg-bg-secondary">
        <div className="container">
          <div className="max-w-[900px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              {/* Image */}
              <div className="relative rounded-2xl overflow-hidden shadow-lg-custom">
                <img
                  src="/images/RetroGrillLogo.webp"
                  alt="Retro Grill Food Truck"
                  className="w-full h-[300px] lg:h-[400px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent"></div>
              </div>

              {/* Content */}
              <div>
                <h2 className="font-display text-2xl font-semibold text-text-primary mb-6">
                  Make Your Event a Crowd Favorite
                </h2>
                <p className="text-text-secondary text-lg leading-relaxed mb-6">
                  Planning a private party, office lunch, school event, or
                  wedding weekend? Retro Grill offers full-service catering for
                  gatherings of all sizes, with a menu your guests will
                  actually get excited about.
                </p>
                <p className="text-text-secondary text-lg leading-relaxed mb-8">
                  Build your spread with customer favorites like Maryland Crab
                  Cakes, Smash Burgers, Nashville Hot Chicken Sammies, Wings,
                  Wraps, and classic sides. We can customize options to fit
                  your vibe, guest count, and budget.
                </p>

                <div className="bg-bg-card border border-border-default rounded-xl p-6">
                  <h3 className="font-display font-semibold text-text-primary mb-3">
                    Ready to Start Planning?
                  </h3>
                  <p className="text-text-secondary mb-5">
                    Send us your event details and we will help you create a
                    custom Retro Grill catering package.
                  </p>
                  <Link to="/contact" className="btn btn-primary btn-large">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
